module.exports = __webpack_public_path__ + "img/img_coupon_internet_cover.773a3059.png";